export const navItems: any[] = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    iconComponent: { name: 'cil-speedometer' },
  },
  {
    name: 'Data',
    title: true
  },
  {
    name: 'Clinics',
    url: '/dashboard/clinics',
    iconComponent: { name: 'cil-people' },
    roles: ['USER']
  },
  {
    name: 'Customers',
    url: '/dashboard/customers',
    iconComponent: { name: 'cil-people' },
    roles: ['ADMINISTRATOR']
  },
  {
    name: 'Patients',
    url: '/dashboard/patients',
    iconComponent: { name: 'cil-user-follow' },
    roles: ['ADMINISTRATOR', 'USER']
  },
  {
    name: 'Tests',
    url: '/dashboard/tests',
    iconComponent: { name: 'cil-medical-cross' },
    roles: ['ADMINISTRATOR', 'USER']
  },
  {
    name: 'Manage',
    title: true,
    roles: ['ADMINISTRATOR', 'USER']
  },
  {
    name: 'Users',
    url: '/dashboard/users',
    iconComponent: { name: 'cil-people' },
    roles: ['ADMINISTRATOR', 'USER']
  },
  {
    name: 'Roles',
    url: '/dashboard/users/roles',
    iconComponent: { name: 'cil-lock-locked' },
    roles: ['ADMINISTRATOR']
  },
  {
    name: 'Parameters',
    url: '/dashboard/parameters',
    iconComponent: { name: 'cil-applications' },
    roles: ['ADMINISTRATOR']
  },
  {
    name: 'Location',
    url: '/dashboard/locations',
    iconComponent: { name: 'cil-location-pin' },
    roles: ['ADMINISTRATOR'],
    children: [
      {
        name: 'City',
        url: '/dashboard/cities',
        iconComponent: { name: 'cil-map' },
      },
      {
        name: 'State',
        url: '/dashboard/states',
        iconComponent: { name: 'cil-map' },
      },
      {
        name: 'Country',
        url: '/dashboard/countries',
        iconComponent: { name: 'cil-map' },
      },
    ]
  },
];
